import React, { useState } from 'react';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import ArrowDownIcon from '@tradera/blueprint/theme/icons2/arrow-down.svg?jsx';
import { useTranslator } from 'tradera-lang/translate';
import { mapCountryCodeToCountryKey } from 'tradera-utils/map-country-code-to-country-key';
import Flag from 'tradera-components/flag/flag';
import './shipping-country-select-dropdown.scss';

export const ShippingCountrySelectDropdown = ({
    shippingCountries,
    selectedShippingCountry,
    onSelect
}) => {
    const { t } = useTranslator();
    const [searchFocus, setSearchFocus] = useState(false);
    const [search, setSearch] = useState('');
    const [isSearchEnabled, setIsSearchEnabled] = useState(false);
    const includesSearch = v => v.toLowerCase().includes(search.toLowerCase());
    const filteredShippingCountries = shippingCountries
        .map(countryCodeIso2 => ({
            countryCodeIso2,
            name: t(mapCountryCodeToCountryKey(countryCodeIso2))
        }))
        .filter(
            ({ name, countryCodeIso2 }) =>
                includesSearch(name) || includesSearch(countryCodeIso2)
        );

    const listStyle = {
        height:
            filteredShippingCountries.length < 6
                ? `${(filteredShippingCountries.length || 1) * 35}px`
                : '165px'
    };

    const Row = ({ index, style }) => (
        <div
            className="shipping-country-select-row d-flex list-group-item list-group-item-action px-0"
            style={style}>
            <label
                className="d-flex align-items-center w-100 h-100 pl-0 text-gray-600 text-truncate"
                onClick={() =>
                    onSelect(filteredShippingCountries[index].countryCodeIso2)
                }>
                <Flag
                    className="mr-1"
                    countryCodeIso2={
                        filteredShippingCountries[index].countryCodeIso2
                    }
                />
                {filteredShippingCountries[index].name}
            </label>
        </div>
    );

    return (
        <>
            <span className="d-flex align-items-center">
                {!isSearchEnabled ? (
                    <>
                        <button
                            className="btn btn-outline-dark flex-grow-1 d-flex justify-content-between align-items-center "
                            onClick={() => {
                                setIsSearchEnabled(true);
                                setSearchFocus(true);
                            }}>
                            {t(
                                mapCountryCodeToCountryKey(
                                    selectedShippingCountry.countryCodeIso2
                                )
                            )}
                            <ArrowDownIcon className="icon" />
                        </button>
                    </>
                ) : (
                    <>
                        <input
                            type="text"
                            className="form-control form-control-rounded"
                            name="shippingCountry"
                            placeholder={t(
                                'siteHeader_shippingCountryPlaceholder'
                            )}
                            aria-label={t(
                                'siteHeader_shippingCountryPlaceholder'
                            )}
                            role="search"
                            value={search}
                            autoComplete="off"
                            onChange={e => setSearch(e.target.value)}
                            onFocus={() => setSearchFocus(true)}
                            onBlur={() => {
                                setTimeout(() => {
                                    setSearchFocus(false);
                                }, 100);
                            }}
                        />
                        <button
                            className="clear-button unbutton icon"
                            onClick={() => {
                                setSearch('');
                                setSearchFocus(false);
                                setIsSearchEnabled(false);
                            }}>
                            <CloseIcon className="icon icon-dark" />
                        </button>
                    </>
                )}
            </span>
            <span>
                {isSearchEnabled && (search || searchFocus) && (
                    <div
                        className="bg-white pt-2"
                        onMouseDown={e => e.preventDefault()}
                        style={listStyle}>
                        {filteredShippingCountries.length > 0 ? (
                            <AutoSizer>
                                {({ height, width }) => (
                                    <FixedSizeList
                                        className="list-group"
                                        itemCount={
                                            filteredShippingCountries.length
                                        }
                                        itemSize={35}
                                        height={height}
                                        width={width}>
                                        {Row}
                                    </FixedSizeList>
                                )}
                            </AutoSizer>
                        ) : (
                            <div className="list-group w-100">
                                <div className="d-flex list-group-item list-group-item-action">
                                    {t('siteHeader_shippingCountryNoResults')}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </span>
        </>
    );
};
